<app-page-title titleHeading='Cards examples 1' titleDescription='Wide selection of cards with multiple styles, borders, actions and hover effects.'></app-page-title>
<app-example-wrapper-seamless sectionHeading="Cards 1">
  <app-cards1-examples-1></app-cards1-examples-1>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 2">
  <app-cards1-examples-2></app-cards1-examples-2>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 3">
  <app-cards1-examples-3></app-cards1-examples-3>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 4">
  <app-cards1-examples-4></app-cards1-examples-4>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 5">
  <app-cards1-examples-5></app-cards1-examples-5>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 6">
  <app-cards1-examples-6></app-cards1-examples-6>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 7">
  <app-cards1-examples-7></app-cards1-examples-7>
</app-example-wrapper-seamless>

